import { DileModal } from './src/DileModal.js';

customElements.define("dile-modal", DileModal);